import { createFileRoute } from "@tanstack/react-router";
import { CreateReportForm } from "~/components/CreateReportForm";
import { PageLoading } from "~/components/PageLoading";
import { WithStudentNav } from "~/components/WithStudentNav";
import { trpc } from "~/utils/trpc.client";

export const Route = createFileRoute(
  "/_authed/$teamId/students/$studentId/reports/new-report-types",
)({
  component: StudentReportTypesPage,
});

function StudentReportTypesPage() {
  const { teamId, studentId } = Route.useParams();
  const reportTypesQuery = trpc.reportTypes.getReportTypes.useQuery({ teamId });

  return (
    <WithStudentNav>
      <div className="m-auto flex w-full max-w-[800px] flex-col gap-2 p-4">
        <div className="flex w-full items-center justify-between gap-2">
          <h2 className="text-xl font-bold">Choose a report type</h2>
          <div></div>
        </div>
        {!reportTypesQuery.data ? (
          <PageLoading />
        ) : (
          <div className="grid grid-cols-[repeat(auto-fill,minmax(30ch,1fr))] gap-4">
            {reportTypesQuery.data.map((reportType) => (
              <CreateReportForm
                key={reportType.id}
                teamId={teamId}
                studentId={studentId}
                reportTypeId={reportType.id}
                className="card bg-base-100 shadow"
              >
                  <div className="card-body">
                    <div className="flex items-center">
                      <div className="avatar avatar-placeholder w-10">
                        <div className="text-primary-content w-24 rounded-full bg-sky-600">
                          <span className="text-lg">
                            {reportType.name
                              .split(" ")
                              .map((name) => name[0])
                              .slice(0, 2)
                              .join("")
                              .toUpperCase()}
                          </span>
                        </div>
                      </div>
                      <div className="ml-3 flex flex-col items-start gap-2">
                        <h2 className="card-title text-left">
                          {reportType.name}
                        </h2>
                        <p className="text-sm text-gray-600">
                          {reportType.description}
                        </p>
                        <p className="mt-4 text-sm text-gray-600">
                          Last updated{" "}
                          <>{reportType.updatedAt.toLocaleString()}</>
                        </p>
                      </div>
                    </div>
                  </div>
              </CreateReportForm>
            ))}
          </div>
        )}
      </div>
    </WithStudentNav>
  );
}
